import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import TextStyles from './styles/text';
import PageOutline from './styles/PageOutline';
import GenericPage from './pages/GenericPage';
import {
  indexPageConfig,
  businessPageConfig,
  customerPageConfig,
  aboutPageConfig,
  addNewSpotPageConfig,
  categoryPageConfig,
  dahabGuidePageConfig,
} from './config/pageConfigs';

const App: React.FC = () => {
  return (
    <Router>
      <PageOutline/>
      <GlobalStyles />
      <TextStyles />
      <Switch>
        <Route exact path="/" render={() => <GenericPage config={indexPageConfig} />} />
        <Route exact path="/business" render={() => <GenericPage config={businessPageConfig} />} />
        <Route exact path="/customer" render={() => <GenericPage config={customerPageConfig} />} />
        <Route path="/about-us" render={() => <GenericPage config={aboutPageConfig} />} />
        <Route path="/business/add-a-new-spot" render={() => <GenericPage config={addNewSpotPageConfig} />} />
        <Route path="/customer/category" render={() => <GenericPage config={categoryPageConfig} />} />
        <Route path="/customer/dahab-guide" render={() => <GenericPage config={dahabGuidePageConfig} />} />
      </Switch>
    </Router>
  );
};

export default App;